import api from '../api';
import { downloadOrViewArquivo } from '@app/helpers/download';

export interface sasFornecedorPainel {
  compliaceComentario: any;
  financeiroComentario: any;
  confideComentario: any;
  compliaceFormat: any;
  compliace: any;
  financeiroFormat: any;
  financeiro: any;
  confideFormat: any;
  confide: any;
  id: string;
  codigoTotvs: string;
  cnpj: string;
  razaoSocial: string;
  sasFornecedorAvaliacaoCompliance: sasFornecedorAvaliacoes[];
  sasFornecedorAvaliacaoFinanceira: sasFornecedorAvaliacoes[];
  sasSFornecedorAvaliacaoConfide: sasFornecedorAvaliacoes[];

  naturezaFornecedor?: string;
}

export interface sasFornecedorFrom {
  id: string;
  codigoTotvs: string;
  cnpj: string;
  razaoSocial: string;
  naturezaFornecedor?: string;
}

export interface sasFornecedorAvaliacoes {
  nome: string;
  id: string;
  index: number;
  sasFornecedorId: string;
  dataValidade: Date;
  dataValidadeFormatada: string;
  comentario: string;
  resultadoAnaliseAvaliacaoFinanceira: string;
}

//SasFornecedorPainel

export const getAllSasFornecedorPainel = () => api.get<sasFornecedorPainel[]>('sasFornecedor/sasFornecedorPainel');
export const createSasFornecedorPainel = (form: sasFornecedorFrom) =>
  api.post<any>('sasFornecedor/sasFornecedorPainel', form);
export const deleteSasFornecedorPainel = (id: string) => api.delete(`sasFornecedor/sasFornecedorPainel/${id}`);
export const getAllSasFornecedorPainelComAvaliacoes = (id: string) =>
  api.get<sasFornecedorPainel>(`sasFornecedor/sasFornecedorPainel/${id}`);
export const updateFornecedorPainel = (form: sasFornecedorFrom) =>
  api.put<any>('sasFornecedor/sasFornecedorPainel', form);

//SasFornecedorOc
export const getByUsuarioIdSasFornecedorOc = (usuarioId: string) =>
  api.get<sasFornecedorFrom[]>(`sasFornecedor/sasFornecedorOcByUsuarioId/${usuarioId}`);

export const getByIdSasFornecedorOc = (id: string) => api.get<sasFornecedorFrom>(`sasFornecedor/${id}`);

export const createSasFornecedorOc = (form: sasFornecedorFrom) =>
  api.post<any>('sasFornecedor/sasFornecedorPainel', form);

export const updateSasFornecedorOc = (form: sasFornecedorFrom) =>
  api.put<any>('sasFornecedor/updateSasFornecedor', form);

export const verificaRespostaCartaConvite = (fornecedorOcId: string, ordemCompraId: string) =>
  api.get<any>(`sasFornecedor/verificarRespostaCartaConvite/${ordemCompraId}/${fornecedorOcId}`);

export const getAcoesFornecedor = (ordemCompraId: string, sasFornecedorOcId?: string) =>
  api.get<any>(`sasFornecedor/acoes/${ordemCompraId}${sasFornecedorOcId ? `?sasFornecedorOcId=${sasFornecedorOcId}` : ''}`);

export const getFornecedoresOc = (ordemCompraId: string) =>
  api.get<{ id: string; nome: string }[]>(`sasFornecedor/acoes/${ordemCompraId}/fornecedores`);

export const executarAcaoFornecedor = (data: FormData) =>
  api.post('sasFornecedor/acoes/executar', data);

export const downloadTemplateEsclarecimentoTecnico = () => {
  downloadOrViewArquivo({
    url: '/api/sasFornecedor/downloadTemplateEsclarecimentoTecnico',
    nomeDoArquivo: 'Formulario_Esclarecimento_Tecnico.xlsx',
    atributoId: 'downloadTemplateEsclarecimentoTecnico',
  });
};